import React from "react";
import { Star, StarHalf } from "lucide-react";

export const StarRating = ({ rating = 5, size = "w-4 h-4", showText = false, count = 0 }) => {
  const fullStars = Math.floor(rating);
  const hasHalf = rating % 1 >= 0.3;
  const emptyStars = 5 - fullStars - (hasHalf ? 1 : 0);

  return (
    <div className="flex items-center gap-1">
      <div className="flex">
        {[...Array(fullStars)].map((_, i) => (
          <Star key={`f${i}`} className={`${size} fill-amber-400 text-amber-400`} />
        ))}
        {hasHalf && <StarHalf className={`${size} fill-amber-400 text-amber-400`} />}
        {[...Array(emptyStars)].map((_, i) => (
          <Star key={`e${i}`} className={`${size} text-gray-200`} />
        ))}
      </div>
      {showText && count > 0 && (
        <span className="text-xs text-gray-500 ml-1">({count})</span>
      )}
    </div>
  );
};

export const TrustpilotBadge = ({ className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`} data-testid="trustpilot-badge">
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="#00b67a" />
    </svg>
    <div className="flex flex-col leading-tight">
      <div className="flex items-center gap-1">
        <span className="font-bold text-sm text-gray-800">Trustpilot</span>
        <div className="flex">
          {[...Array(5)].map((_, i) => (
            <Star key={i} className="w-3 h-3 fill-[#00b67a] text-[#00b67a]" />
          ))}
        </div>
      </div>
      <span className="text-xs text-gray-500">Rated 4.9/5 from 100,247 reviews</span>
    </div>
  </div>
);

export const TrustpilotBanner = () => (
  <div className="bg-white border rounded-xl p-6 text-center" data-testid="trustpilot-banner">
    <div className="flex items-center justify-center gap-2 mb-3">
      <svg viewBox="0 0 24 24" className="w-8 h-8" fill="none">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="#00b67a" />
      </svg>
      <span className="text-2xl font-bold text-gray-800">Trustpilot</span>
    </div>
    <div className="flex justify-center gap-1 mb-2">
      {[...Array(5)].map((_, i) => (
        <Star key={i} className="w-6 h-6 fill-[#00b67a] text-[#00b67a]" />
      ))}
    </div>
    <p className="text-lg font-semibold text-gray-800">Rated <span className="text-[#00b67a]">Excellent</span></p>
    <p className="text-sm text-gray-500 mt-1">4.9 out of 5 based on <strong>100,247</strong> reviews</p>
  </div>
);
